import { sendEventToJumbo } from './jumbo';

export const NEW_USER_EVENTS = {
  NEW_USER_EMPRESSION_EVENTS: 'new_user_empression_event',
};

export const sendNewUserImpressionEvents = (customerId) => {
  sendEventToJumbo({
    eventName: NEW_USER_EVENTS.NEW_USER_EMPRESSION_EVENTS,
    customerId,
  });
};
